import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import { API_ROUTES } from "../../api/ApiRoutes";
import { getPrivateInstance } from "../_privateInstance";
import { isAxiosForbidden } from "./httpErrors";
import { parseStaffRegulatorList } from "./parseStaffRegulator";
import type { StaffRegulator, StaffRegulatorEnvelope } from "./types";

export const STAFF_REGULATORS_LIST_QUERY_KEY = [
  "staff-regulators",
  "list",
] as const;

export const fetchStaffRegulatorsList = async (): Promise<StaffRegulator[]> => {
  const response = await getPrivateInstance().get<
    StaffRegulatorEnvelope<unknown>
  >(API_ROUTES.STAFF_REGULATORS);
  return parseStaffRegulatorList(response.data?.data);
};

export const useStaffRegulatorsList = (): UseQueryResult<
  StaffRegulator[],
  Error
> =>
  useQuery<StaffRegulator[], Error>({
    queryKey: STAFF_REGULATORS_LIST_QUERY_KEY,
    queryFn: fetchStaffRegulatorsList,
    retry: (failureCount, error) =>
      !isAxiosForbidden(error) && failureCount < 1,
    staleTime: 1000 * 30,
    refetchOnWindowFocus: false,
  });
